export default "/images/redirectMonitor.png?8ce426f9e532fbdaef561e5f988834a7";